import './styles/app.css';
import './styles/jv-theme.css';
import './components/jv-app';
import {
  JvSidebar,
  JvOperatorApp,
  JvOperatorLogin,
  JvOperatorDashboard,
  JvOperatorTenants,
  JvOperatorResourcePage,
} from './operator/pages/operator';

customElements.define('jv-sidebar', JvSidebar);
customElements.define('jv-operator-app', JvOperatorApp);
customElements.define('jv-operator-login', JvOperatorLogin);
customElements.define('jv-operator-dashboard', JvOperatorDashboard);
customElements.define('jv-operator-tenants', JvOperatorTenants);
customElements.define('jv-operator-resource', JvOperatorResourcePage);
